import React from "react";

/**
 * SUX1 logo with a subtle French-flag fade-in animation on mount.
 *
 * Behaviour:
 *  - On mount, three vertical bands (bleu-blanc-rouge) fade in *behind* the
 *    "SUX1" letters, hold briefly, then fade out — restoring the normal logo.
 *  - The animation runs once per component mount (page load).
 *  - Respects `prefers-reduced-motion`: users who opted out get the static logo.
 *
 * Sizes:
 *  - "sm"  → header (h-7 icon, text-2xl)
 *  - "lg"  → login/splash (h-8 icon, text-3xl)
 */
export const Sux1Logo = ({ size = "sm", className = "" }) => {
  const isLarge = size === "lg";
  const iconSize = isLarge ? "w-8 h-8" : "w-7 h-7";
  const textSize = isLarge ? "text-3xl" : "text-2xl";

  return (
    <span
      className={`sux1-logo relative inline-flex items-center gap-3 ${className}`}
      data-testid="sux1-logo"
    >
      {/* Icon — cycles bleu → blanc → rouge → bleu once */}
      <img
        src="/icons/sux1-192.png"
        alt=""
        className={`sux1-logo__icon inline-block ${iconSize}`}
        aria-hidden="true"
      />

      {/* Wordmark with animated tricolore layer sitting behind the letters */}
      <span
        className={`sux1-logo__wordmark relative font-black ${textSize} tracking-tight`}
        style={{ fontFamily: "Outfit" }}
      >
        {/* Tricolore backdrop — absolute, fades in/out once on mount */}
        <span className="sux1-logo__flag" aria-hidden="true">
          <span className="sux1-logo__band sux1-logo__band--blue" />
          <span className="sux1-logo__band sux1-logo__band--white" />
          <span className="sux1-logo__band sux1-logo__band--red" />
        </span>

        {/* Letters sit on top */}
        <span className="sux1-logo__letters relative">
          SUX<span className="text-[#FF2A00]">1</span>
        </span>
      </span>
    </span>
  );
};

export default Sux1Logo;
